import { UserRole } from '../enums';

const userRoleCheckers = {
  isAdmin: (role) => role === UserRole.ADMIN,
  isEditor: (role) => role === UserRole.EDITOR,
  isWriter: (role) => role === UserRole.WRITER,
  isCustomer: (role) => role === UserRole.CUSTOMER,
  isDevelopmentalEditor: (role) => role === UserRole.DEVELOPMENTAL_EDITOR,
  isSale: (role) => role === UserRole.SALE,
  isContentTeam: (role) => role === UserRole.CONTENT_TEAM,
  isProProofreader: (role) => role === UserRole.PRO_PROOFREADER,
};

export default userRoleCheckers;
